// extracted by mini-css-extract-plugin
export var aboveInput = "_mw-0";
export var actionButton = "_mw-5";
export var actionButtonContainer = "_mw-1";
export var actionIcon = "_mw-6";
export var aiInfoContainer = "_mw-2";
export var attachmentWrapper = "_mw-7";
export var bold = "_mw-3";
export var checkIcon = "_mw-8";
export var clickingRecipientBar = "_mw-11";
export var commentThreadSwitch = "_mw-a";
export var draftImage = "_mw-b";
export var draftImageContainer = "_mw-c";
export var draftImages = "_mw-e";
export var editButton = "_mw-g";
export var editor = "_mw-f";
export var editorContainer = "_mw-y";
export var editorErrorTooltipWrapper = "_mw-9";
export var headerDivider = "_mw-h";
export var icon = "_mw-i";
export var info = "_mw-j";
export var internal = "_mw-n";
export var internalDivider = "_mw-k";
export var internalMessage = "_mw-l";
export var messageInputCard = "_mw-m";
export var messageInputForm = "_mw-o";
export var messageInputFormInternal = "_mw-p";
export var options = "_mw-q";
export var publicMessageCustomer = "_mw-s";
export var publicMessageMerchant = "_mw-r";
export var removeImageButton = "_mw-d";
export var replyButtons = "_mw-t";
export var showSignatureButton = "_mw-u";
export var spinner = "_mw-v";
export var verticalButtonDivider = "_mw-4";
export var visibilitySelector = "_mw-w";
export var warning = "_mw-x";
export var wrappingText = "_mw-z";
export var writingInternalNoteTopBorder = "_mw-10";